import { render, staticRenderFns } from "./WidthHeightField.vue?vue&type=template&id=de608e4a&scoped=true"
import script from "./WidthHeightField.vue?vue&type=script&lang=ts"
export * from "./WidthHeightField.vue?vue&type=script&lang=ts"
import style0 from "./WidthHeightField.vue?vue&type=style&index=0&id=de608e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de608e4a",
  null
  
)

export default component.exports